import * as React from 'react'
import { FC } from 'react'
import { useBreakpoints } from '../../../shared/hooks/useBreakpoints'

export const Col: FC<{
    children?: React.ReactElement | string | boolean | undefined | (React.ReactElement | string | boolean | undefined)[],
    style?: React.CSSProperties,
    sm?: number,
    md?: number,
    lg?: number,
    xl?: number,
}> = ({children, style, sm = 12, md, lg, xl}) => {
    const bp = useBreakpoints()

    const cols = bp.sm ? sm 
        : bp.md ? md ?? sm
        : bp.lg ? lg ?? md ?? sm
        : xl ?? lg ?? md ?? sm
    
    const width = Math.floor(cols/12 * 100)

    return (
        <div style={{...style, width: `calc(${width}% - var(--spacer-S) * ${12-cols}/12)`}}>
            {children}
        </div>
    )
}
